import Const from 'constants';

const defaultState = {
    data: {
        projectionPointsType: 'userPoints',
    },
    getProjectionPointsType() {
        return this.data.projectionPointsType;
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.SET_PROJECTION_POINTS_TYPE) {
        state = {...state};
        state.data.projectionPointsType = action.value;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: {
                projectionPointsType: 'userPoints',
            },
        };
    }

    return state;
}
